import {
  SET_DEFAULT_ADD_MOVIE_TITLE,
} from '../../actions/action-types';


export function setDefaultAddMovieTitle(defaultAddMovieTitle = null) {
  return { type: SET_DEFAULT_ADD_MOVIE_TITLE, payload: { defaultAddMovieTitle } };
}

/*
export function setComingSoonAddContext(movieId, movie) {
  return { type: SET_COMING_SOON_ADD_CONTEXT, payload: { movieId, movie } };
} */
